import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';
// Redux
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { RootState } from 'app/store';

const SpinStyled = styled(Spin)`
  .ant-spin-nested-loading > div > .ant-spin-lg .ant-spin-text {
    padding-top: 43px;
    color: #000000 !important;
  }
  .ant-spin-dot-item {
    background-color: #ffffff;
  }
  .ant-spin-dot-item:nth-child(1) {
    opacity: 1;
  }
  .ant-spin-dot-item:nth-child(2) {
    opacity: 0.8;
  }
  .ant-spin-dot-item:nth-child(3) {
    opacity: 0.6;
  }
`;

/** phần loading trạng thái tải dữ liệu của trang đăng nhập khung load sẽ trọn màn hình */
export default function LoadingPage() {
  const { t } = useTranslation();
  // Redux
  const isLoadingApi = useSelector((state: RootState) => state.select.isLoadingApi);

  // Loading hiện tối thiểu 500ms để không chớp màn hình khi API trả về quá nhanh.
  // Vd: API xong sau 100ms -> chờ thêm 400ms mới ẩn; API xong sau 2s -> ẩn ngay.
  // Bật lại trong lúc đang chờ ẩn thì huỷ hẹn giờ cũ (cleanup), không tắt nhầm loading của request mới.
  const [visible, setVisible] = useState(isLoadingApi);
  const shownAt = useRef(0);
  useEffect(() => {
    if (isLoadingApi) {
      shownAt.current = Date.now();
      setVisible(true);
      return;
    }
    const timer = setTimeout(() => setVisible(false), Math.max(0, 500 - (Date.now() - shownAt.current)));
    return () => clearTimeout(timer);
  }, [isLoadingApi]);

  return (
    <div
      className={classNames(
        visible ? 'fixed' : 'hidden',
        'h-full z-[9999] inset-0 w-full fixed bg-gray-100 bg-opacity-50 !select-none cursor-wait'
      )}
    >
      <div className="flex justify-center items-center h-full">
        <div className="text-center w-[100px] h-[100px] bg-black bg-opacity-50 rounded-md p-3 flex justify-center items-center">
          <div className="">
            <div className="flex justify-center pt-5">
              <SpinStyled tip={''} size="large">
                <div className="content" />
              </SpinStyled>
            </div>

            <p className="text-base text-center text-white !pt-5 !pb-0">{t('System.ApiLoading')}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
